<template>
  <div id="app" :class="{holding : GET_SIDEBAR_OPEN}" :style="{height:screenHeight}">
    <div class="spinner" v-if="isLoading">
    <transition name="slide-fade" mode="in-out" v-if="isLoading">
      <beat-loader :loading="isLoading" :color="loader.color" :size="loader.size"></beat-loader>
    </transition>
    </div>
    <router-view :class="{none : isLoading}" v-if="isView"/>

    <add-popup-header-app v-if="checkPopupHeaderMain"
                      :popupSetMain="popupSetMain"/>
  </div>

</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import {
  setCookie,
  getCookie, removeCookie
} from './utils/cookieNew'
import { hasNotch, NOTCH_HEIGHT } from './utils/checkDevice'
import BeatLoader from 'vue-spinner/src/BeatLoader'
import AddPopupHeaderApp from './components/AddPopupHeaderApp'
import EventBus from './utils/bus'
export default {
  name: 'Common',
  data () {
    return {
      screenHeight: '100%',
      popupSetMain: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '',
        confirmBtnText: '확인',
        count: 'single',
        nextLink: '',
        closeType: 'close'
      },
      loader: {
        loading: false,
        color: '#ff6565',
        size: '18px'
      },
      view: {
        deviceAct: true,
        versionAct: true,
        autoLoginAct: true
      },
      os: '',
      version: '',
      mobileInfo: {
        result: false
      },
      isView: true,
      verifyAutoLogic: false,
      loginLogicPassed: false
    }
  },
  computed: {
    ...mapGetters([
      'GET_SIDEBAR_OPEN',
      'getVersion',
      'GET_PUSH_LIST'
    ]),
    ...mapGetters('push', [
      'getPushCounted'
    ]),
    ...mapState([
      'isLoading',
      'checkPopupHeaderMain'
    ])
  },
  components: {
    BeatLoader,
    AddPopupHeaderApp
  },
  created () {
    /* 버전체크 이후 IOS 대용으로 옮기고 싶음 */
    if ((sessionStorage.getItem('userAgent') === null) && (location.pathname === '/')) {
      this.loading(true)
    } else if ((sessionStorage.getItem('userAgent') === null) && (location.pathname !== '/')) {
      window.callbackDeviceInfo = this.callbackDeviceInfo
      window.callbackAutoLogin = this.callbackAutoLogin
      console.log('디바이스 정보를 못 가져왔음 - 초회 진입 -')
      this.initWebViewDeviceInfo(1, 1, 1)
    }
  },
  methods: {
    ...mapActions([
      'AUTO_LOGIN',
      'VERSION_CHECK',
      'PUSH_LIST'
    ]),
    ...mapMutations([
      'SET_DEVICE_PUSHKEY',
      'SET_DEVICE_DEVICEID',
      'SET_DEVICE_APPVERSION',
      'SET_DEVICE_DEVICE',
      'SET_POPUP_HEADER_MAIN',
      'loading'
    ]),
    ...mapMutations('push', [
      'SET_PUSHCOUNTED'
    ]),
    async patchPushList () {
      console.log('푸시리스트 api 실행 (전역앱에서)')
      try {
        await this.PUSH_LIST()
          .then(() => {
            this.patchData()
          })
      } catch (error) {
        console.log('푸시실패 처리 후 이동경로', sessionStorage.getItem('pathToLoadAuthPre'))
        console.log('푸시리스트 api 실패함')
      }
    },
    patchData () {
      const InactivityArray = []
      let count = 0
      for (let i = 0; i < this.GET_PUSH_LIST.length; i++) {
        // 읽지않은 푸시 담기
        if (this.GET_PUSH_LIST[i].is_read === false) {
          InactivityArray.push(String(i))
          // 뱃지카운트 계산해
          count++
        }
      }
      console.log('뱃지카운트 구하는데 진입')
      console.log('찾아온 뱃지카운트', count)
      this.SET_PUSHCOUNTED(count)
    },
    refresh () {
      console.log('리프레쉬 진입')
      let _startY
      const inbox = document.querySelector('.appContext')
      console.log('inbox: ', inbox)
      if (inbox !== null) {
        inbox.addEventListener('touchstart', e => {
          _startY = e.touches[0].pageY
        }, { passive: true })
        inbox.addEventListener('touchmove', e => {
          const y = e.touches[0].pageY
          // Activate custom pull-to-refresh effects when at the top of the container
          // and user is scrolling up.
          if (document.scrollingElement.scrollTop === 0 && y - 60 > _startY &&
          !document.body.classList.contains('refreshing')) {
          // refresh inbox.
            this.simulateRefreshAction()
          }
        }, { passive: true })
      }
    },
    /* 당겨서 새로고침 액션 */
    async simulateRefreshAction () {
      console.log('실제로 리프레시가 실행됨')
      const sleep = (timeout) => new Promise(resolve => setTimeout(resolve, timeout))
      document.body.classList.add('refreshing')
      await sleep(1000)
      await this.transAfter()
    },
    async transAfter () {
      const refresher = document.querySelector('.refresher')
      const sleep = (timeout) => new Promise(resolve => setTimeout(resolve, timeout))
      refresher.classList.add('shrink')
      await this.frezzer()
      refresher.classList.add('done')
      refresher.classList.remove('shrink')
      document.body.classList.remove('refreshing')
      await sleep(0) // let new styles settle.
      await this.frezzer()
      refresher.classList.remove('done')
    },
    async frezzer () {
      if (!this.isView) {
        this.loading(false)
        this.isView = !this.isView
      } else {
        this.loading(true)
        this.isView = !this.isView
      }
    },
    /* 모바일로 진입했을때 버전 체크 */
    async versionCheck () {
      if (getCookie('device') !== undefined) {
        console.log('버전 로직 진입')
        console.log('os: ' + getCookie('device'))
        console.log('version: ' + getCookie('appVersion'))
        this.os = getCookie('device')
        this.version = getCookie('appVersion')
        if (this.os === 'A') {
          this.os = 'Android'
        } else if (this.os === 'I') {
          this.os = 'iOS'
        }
        const payload = {
          os: this.os,
          version: this.version
        }
        console.log('payload: ', payload)
        console.log('payload.os: ', payload.os)
        console.log('payload.version: ', payload.version)
        try {
          await this.VERSION_CHECK(payload)
            .then(() => {
              console.log('check:', this.getVersion.check)
              console.log('os:', this.getVersion.os)
              console.log('version:', this.getVersion.version)
              console.log('option:', this.getVersion.option)
              console.log('url:', this.getVersion.url)
              if (this.getVersion.option === 1) {
                this.SET_POPUP_HEADER_MAIN(true)
                this.popupSetMain.count = 'mobileAction'
                this.popupSetMain.closeType = 'close'
                this.popupSetMain.content = '업데이트 버전이 있습니다. 확인을 누르면 업데이트 하실 수 있습니다.'
                this.popupSetMain.mobileLink = this.getVersion.url
                this.mobileInfo.result = true
              } else if (this.getVersion.option === 2) {
                this.SET_POPUP_HEADER_MAIN(true)
                this.popupSetMain.count = 'mobileAction'
                this.popupSetMain.closeType = 'mobileAction'
                this.popupSetMain.content = '최신 버전으로 업데이트 후 앱 사용이 가능합니다.'
                this.popupSetMain.mobileLink = this.getVersion.url
                this.mobileInfo.result = false
              } else if (this.getVersion.option === 0) {
                console.log('현재 버전의 옵션은: ', this.getVersion.option)
                this.mobileInfo.result = true
              } else {
                console.log('알 수 없는 버전임 (버전체크로 감지못함)')
                console.log('현재 버전의 옵션은: ', this.getVersion.option)
                this.mobileInfo.result = false
              }
            })
        } catch (e) {
          console.log('error: ', e)
          console.log('버전체크 API 실패')
          this.mobileInfo.result = false
        } finally {
        }
      } else {
        console.log('버전체크 시도했으나 디바이스 정보가 없음 (빠지면 안되는 오류)')
        this.mobileInfo.result = false
      }
    },
    initWebViewDeviceInfo (device, version, autoLogin) {
      if (/thanqApp/.test(navigator.userAgent)) {
        if (device !== 1) {
          this.view.deviceAct = false
        }
        if (version !== 1) {
          this.view.versionAct = false
        }
        if (autoLogin !== 1) {
          this.view.autoLoginAct = false
        }
        console.log('앱에게 디바이스 프로토콜 진입을 요청')
        sessionStorage.setItem('userAgent', 'mobile')
        document.location.href = 'thanq://getDeviceInfo'
      } else {
        console.log('모바일 프로토콜로 진입하지 않음, 인증절차 패스')
        sessionStorage.setItem('userAgent', 'pc')
        setCookie('loginLogicPassed', true, { secure: true, expires: 30 })
        // this.SET_PASSED_LOGIC(true)
        return false
      }
    },
    async executionAutoProtocol () {
      document.location.href = 'thanq://autoLogin'
    },
    async autoLoginFalse () {
      setTimeout(() => {
        if (this.verifyAutoLogic) {
          setCookie('loginLogicPassed', true, { secure: true, expires: 30 })
        }
      }, 1000)
    },
    async initWebViewAutoLogin () {
      if (/thanqApp/.test(navigator.userAgent)) {
        console.log('앱에게 오토로그인 프로토콜 진입을 요청')
        await this.callbackAutoLogin()
        await this.executionAutoProtocol()
        await this.autoLoginFalse()
      }
    },
    async setAutoLoginData (deviceId, fcmToken, device) {
      console.log('오토로그인 API 시작점 진입')
      console.log('세션URL 확인1', sessionStorage.getItem('pathToLoadAuthPre'))
      console.log('세션URL 확인2', sessionStorage.getItem('pathToLoadAuth'))
      console.log('세션URL 확인3', sessionStorage.getItem('pathToLoadUnAuth'))
      try {
        const userData = {
          deviceId: deviceId,
          fcmToken: fcmToken,
          device: device
        }
        await this.AUTO_LOGIN(userData)
          .then(() => {
            console.log('오토로그인 성공후 .then에서 flag값 변경')
            setCookie('loginLogicPassed', true, { secure: true, expires: 30 })
            this.patchPushList()
          })
      } catch (error) {
        removeCookie('token')
        console.log('오토로그인 API 실패:')
        console.log('오토로그인 error: ', error)
        console.log('오토로그인 error Name: ', error.name)
        if (error.status !== 401) {
          if (error.name !== 'NavigationDuplicated') {
            console.log('오토로그인 에러에 진입함')
            console.log('가져온 deviceId', deviceId)
            console.log('가져온 fcmToken', fcmToken)
            console.log('가져온 device', device)
            setCookie('loginLogicPassed', true, { secure: true, expires: 30 })
            // this.SET_PASSED_LOGIC(true)
            return false
          } else {
            console.log('오토로그인 펄스에서 이 에러에 빠지면 안되요..')
            return false
          }
        } else {
          console.log('오토로그인 false & 401에러')
          setCookie('loginLogicPassed', true, { secure: true, expires: 30 })
          this.SET_POPUP_HEADER_MAIN(true)
          this.popupSetMain.content = '권한이 없거나 만료되었습니다. 로그인해주세요'
          this.popupSetMain.mobileLink = '/login'
          this.popupSetMain.count = 'mobileDeleteAuth'
          this.popupSetMain.closeType = 'mobileDeleteAuth'
          return false
        }
      }
    },
    async setDeviceInfoData (fcmToken, deviceId, appVersion, device) {
      setCookie('fcmToken', fcmToken, { secure: true, expires: 30 })
      setCookie('deviceId', deviceId, { secure: true, expires: 30 })
      setCookie('appVersion', appVersion, { secure: true, expires: 30 })
      setCookie('device', device, { secure: true, expires: 30 })
      this.$store.commit('SET_DEVICE_PUSHKEY', fcmToken)
      this.$store.commit('SET_DEVICE_DEVICEID', deviceId)
      this.$store.commit('SET_DEVICE_APPVERSION', appVersion)
      this.$store.commit('SET_DEVICE_DEVICE', device)
      console.log('콜벡디바이스인포 저장됨')
      if (this.view.versionAct) {
        await this.versionCheck()
      }
      if (this.view.autoLoginAct) {
        if (this.mobileInfo.result) {
          console.log('버전체크결과 권고 또는 무시사항으로 오토로그인 로직, view렌더 실행')
          await this.initWebViewAutoLogin()
        } else {
          console.log('버전체크결과 강제로 오토로그인 로직, view렌더 미실행')
        }
      }
    },
    callbackDeviceInfo (getDeviceData) {
      console.log('콜백디바이스 인포 진입')
      if (getDeviceData !== '') {
        const deviceDataSet = JSON.parse(getDeviceData)
        const fcmToken = deviceDataSet.fcmToken
        const deviceId = deviceDataSet.deviceId
        const appVersion = deviceDataSet.appVersion
        const device = deviceDataSet.device
        console.log('=== 콜백디바이스인포에서 가져온 CallbackDeviceInfo 정보 ===')
        console.log(' fcmToken :', fcmToken)
        console.log(' deviceId :', deviceId)
        console.log(' appVersion :', appVersion)
        console.log(' device :', device)
        this.setDeviceInfoData(fcmToken, deviceId, appVersion, device)
      } else {
        console.log('콜백디바이스 인포에서 에러남')
      // 콜백디바이스 인포 에러일떄를 정리하면 좋을 듯
      }
    },
    async callbackAutoLogin (getAutoLogin) {
      console.log('콜백오토로그인의 값', getAutoLogin)
      console.log('콜백 오토로그인 진입')
      if (getAutoLogin !== undefined) {
        this.verifyAutoLogic = false
        const deviceDataSet = JSON.parse(getAutoLogin)
        const deviceId = deviceDataSet.deviceId
        const fcmToken = deviceDataSet.fcmToken
        const sessionToken = deviceDataSet.sessionToken
        console.log('앱에서준 sessionToken', sessionToken)
        setCookie('token', sessionToken, { secure: true, expires: 30 })
        await this.setAutoLoginData(deviceId, fcmToken, getCookie('device'))
      } else {
        this.verifyAutoLogic = !this.verifyAutoLogic
      }
    }
  },
  updated () {
    if ((getCookie('loginLogicPassed') !== undefined) && (this.loginLogicPassed === false) && (this.os === 'iOS')) {
      EventBus.$on('pageAccess', (payload) => {
        if (payload) {
          console.log('노치펑션')
          this.screenHeight = hasNotch() ? (screen.height - NOTCH_HEIGHT) + 'px' : screen.height + 'px'
          this.loginLogicPassed = true
        }
      })
    }
  }
}
</script>

<style lang="scss" >
  @import 'assets/css/main.scss';
  @import 'assets/fonts/stylesheet.css';
</style>
<style lang="scss" scoped>
  .slide-fade-enter-active {
    transition: all .1s ease;
  }
  .slide-fade-leave-active {
    transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */ {
    transform: translateX(10px);
    opacity: 0;
  }
</style>
